/**
 * Theme Context
 * Provides theme state (dark/light) and toggle function to all components.
 * Usage: const { theme, toggle } = useAppTheme();
 */
import { createContext, useContext } from "react";

export const ThemeCtx = createContext({ theme: "dark", toggle: () => {} });
export const useAppTheme = () => useContext(ThemeCtx);
